import { useEffect } from "react";
import * as amplitude from "@amplitude/analytics-browser";
import queryString from "query-string";
import { getAccountsUrl } from "../../../utils/accountsUrl";
import { useHistory } from "react-router-dom";
import LocalStorageService from "../../../core/services/local-storage.service";
import SessionStorageService from "../../../core/services/session-storage.service";
import { useDispatch, useSelector } from "react-redux";
import { userTokenDetailsHandler, clearuserDetailsHandler } from "../../../redux/User/userDetailsSlice";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import Loader from "@components/base/loader/Loader";

const localStorageService = LocalStorageService.getService();
const sessionStorageService = SessionStorageService.getService();
const countryTypeDictionary = (data) => {
  const [countryCode, direction] = data.split("-");
  const selectedObj = globalCountryDetailsDictionary[`${countryCode.toLowerCase()}_${direction.toLowerCase().slice(0, -1)}`];
  return selectedObj?.countryPathName;
};

export default function Us(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.userDetails.userToken);
  const { header } = useSelector((state) => state?.userDetails?.creditDetails);
  const history = useHistory();
  useEffect(() => {
    if (!!queryString.parse(props.location.search).T && queryString.parse(props.location.search).T !== "" && !!queryString.parse(props.location.search).I && queryString.parse(props.location.search).I !== "" && !!queryString.parse(props.location.search).D && queryString.parse(props.location.search).D !== "" && !!queryString.parse(props.location.search).P && queryString.parse(props.location.search).P !== "") {
      let tabIds = localStorageService.getActiveTabIds() || [];
      let isShowReloadLastSearch = sessionStorageService.getShowReloadLastSearchModal();
      localStorageService.clearCompleteStorage();
      if (tabIds !== null) {
        localStorageService.setActiveTabIds(tabIds);
      }
      if (isShowReloadLastSearch !== null) {
        sessionStorageService.setShowReloadLastSearchModal(isShowReloadLastSearch);
      }
      const userData = {
        sso_token: queryString.parse(props.location.search).T,
        session_id: queryString.parse(props.location.search).I,
        session_expiry_date: queryString.parse(props.location.search).D,
        current_product: queryString.parse(props.location.search).P,
        free_trial: queryString.parse(props.location.search).F,
        option_id: queryString.parse(props.location.search).OId ? queryString.parse(props.location.search).OId : 3,
      };
      if (!!queryString.parse(props.location.search).N && queryString.parse(props.location.search).N !== "") {
        userData.navigate = queryString.parse(props.location.search).N;
      }
      if (state && Object.keys(state).length && state?.session_id !== userData?.session_id) {
        localStorage.clear();
        amplitude.reset();
        dispatch(clearuserDetailsHandler());
      }
      dispatch(userTokenDetailsHandler(userData));
      localStorageService.setDataToLocalStorage("userData", userData);
      if (userData.current_product.includes("intel") && userData.free_trial === "true") {
        history.push("/free-trial");
      } else if (!!queryString.parse(props.location.search).Type && queryString.parse(props.location.search).Type !== "D") {
        history.push("/dashboard-mobile");
      } else {
        if (!!queryString.parse(props.location.search).verified && queryString.parse(props.location.search).verified === true) {
          history.push("/hermes-chat");
        } else {
          if (!!queryString.parse(props.location.search).toDash && queryString.parse(props.location.search).toDash.toLowerCase() === "true") {
            history.push("/intel-dashboard");
          } else if (!!queryString.parse(props.location.search).comingFrom && queryString.parse(props.location.search).comingFrom === "Email") {
            let url = `/${countryTypeDictionary(queryString.parse(props.location.search).country.toUpperCase())}?comingFrom=Email&country=` + queryString.parse(props.location.search).country + "&id=" + queryString.parse(props.location.search).id + "&fromDate=" + queryString.parse(props.location.search).fromDate + "&toDate=" + queryString.parse(props.location.search).toDate + "&sort=" + queryString.parse(props.location.search).sort;
            const searchUrlParams = props.location.search;
            let importer = new URLSearchParams(searchUrlParams).get("toImporter");
            let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
            let analyticsKey = new URLSearchParams(searchUrlParams).get("analyticsKey");
            if (importer === "true") {
              url = url + "&toImporter=true";
            } else if (exporter === "true") {
              url = url + "&toExporter=true";
            } else {
              url = url + "&toAnalytics=true";
              if (analyticsKey) {
                url = url + `&analyticsKey=${analyticsKey}`;
              }
            }

            if (!!queryString.parse(props.location.search).country && countryTypeDictionary(queryString.parse(props.location.search).country.toUpperCase())) {
              history.push(url);
            }
          } else if (!!queryString.parse(props.location.search).company_id && queryString.parse(props.location.search).slug && queryString.parse(props.location.search).salesforce && queryString.parse(props.location.search).salesforce !== "") {
            history.push("/companies/" + queryString.parse(props.location.search).slug + "/" + queryString.parse(props.location.search).company_id + "/sfint");
          } else {
            history.push("/hermes-chat");
          }
        }
      }
    } else {
      if (!!queryString.parse(props.location.search).T && queryString.parse(props.location.search).T !== "" && !!queryString.parse(props.location.search).I && queryString.parse(props.location.search).I !== "" && !!queryString.parse(props.location.search).D && queryString.parse(props.location.search).D !== "" && !(!!queryString.parse(props.location.search).P && queryString.parse(props.location.search).P !== "")) {
        localStorageService.clearCompleteStorage();
        const userData = {
          sso_token: queryString.parse(props.location.search).T,
          session_id: queryString.parse(props.location.search).I,
          session_expiry_date: queryString.parse(props.location.search).D,
          current_product: queryString.parse(props.location.search).P,
          option_id: queryString.parse(props.location.search).OId ? queryString.parse(props.location.search).OId : 3,
        };
        localStorageService.setDataToLocalStorage("userData", userData);
        if (!!queryString.parse(props.location.search).Type && queryString.parse(props.location.search).Type !== "D") {
          history.push("/dashboard-mobile");
        } else {
          if (!!queryString.parse(props.location.search).verified && queryString.parse(props.location.search).verified === true) {
            history.push("/search-shipments?verified=true");
          } else {
            history.push("/search-shipments");
          }
        }
      } else {
        window.location.href = getAccountsUrl();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [header]);

  return <Loader />;
}
